<template>
  <div class="container">
    <h1 class="text-uppercase">Premedicated Murder</h1>
    <p class="lead">Shortfilm | 2015 | 24' | Color | English OS

    </p>
    <iframe src="https://player.vimeo.com/video/128769547" width="1066" height="600" frameborder="0"
            allow="autoplay; fullscreen" allowfullscreen></iframe>

    <!--      <img class="img-fluid align-self-center" src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/premedicated-murderwordpress.jpg?alt=media&token=f1fc7fc4-887a-4efd-a397-b3281f6d4f87"  alt="Image">-->
    <p class="lead mt-5 mb-4">A young woman lives in the never-ending circles of her everyday life, depending on medication
      and the security of her daily routine just to make it to the next day. Suddenly her pink rotary phone starts to
      ring and her world is about to break apart.</p>

    <p class="lead">
      <span class="font-weight-normal">DIRECTOR |</span> Anton von Heiseler <br>
      <span class="font-weight-normal">SCRIPT |</span> Fionn Weinmann, Anton von Heiseler <br>
      <span class="font-weight-normal">CINEMATOGRAPHER |</span> Fionn Weinmann, Anton von Heiseler <br>
      <span class="font-weight-normal">EDITOR |</span> Fionn Weinmann, Anton von Heiseler <br>
      <span class="font-weight-normal">SOUND RECORDIST |</span> Julian Moritz <br>
      <span class="font-weight-normal">SOUND DESIGN |</span> Nadja Schulz <br>
      <span class="font-weight-normal">MUSIC |</span> Andreas Fuentes Cannobbio <br>
      <span class="font-weight-normal">PRODUCTION ASSISTANT |</span> Marius Berg <br>
      <br>
      <span class="font-weight-normal">Jenny |</span> Elsa Despoix <br>
      <span class="font-weight-normal">Secretary |</span> Emilia von Heiseler <br>
      <span class="font-weight-normal">Father |</span> Christopher Coote <br>
    </p>


    <a class="btn btn-secondary" href="https://www.youtube.com/watch?v=ysaVP1fDeNs"> Watch Here</a>

  </div>
</template>

<script>
export default {
  name: "premedicatedmurder"
}
</script>

<style scoped>

</style>
